function removeEndSpace(str?: string) {
    if(str) {
        return str.trimEnd()
    } else {
        return ""
    }
}

function isNumeric(str: string) {
    const numericRegex = /^[0-9]+$/;
    return numericRegex.test(str);
  }

export { removeEndSpace, isNumeric }